define('OutSystems/ClientRuntime/modules/Database/IndexedDB/IndexedDBUtils',["require", "exports", "tslib", "../../../DataTypes", "../../../Exceptions", "../EntityInfoUtils"], function (require, exports, tslib_1, DataTypes_1, Exceptions_1, EntityInfoUtils) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getDynamicSortsObjGenerator = exports.loadBinaryDataContent = exports.markEventAsHandled = void 0;
    function markEventAsHandled(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    exports.markEventAsHandled = markEventAsHandled;
    function loadBinaryDataContent(dataToLoad) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var i, listItem;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(dataToLoad instanceof DataTypes_1.List)) return [3, 5];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < dataToLoad.length)) return [3, 4];
                        listItem = dataToLoad.getItem(i);
                        return [4, loadItemContent(listItem)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3, 1];
                    case 4: return [3, 7];
                    case 5:
                        if (!(dataToLoad instanceof DataTypes_1.GenericRecord)) return [3, 7];
                        return [4, loadItemContent(dataToLoad)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2];
                }
            });
        });
    }
    exports.loadBinaryDataContent = loadBinaryDataContent;
    function loadItemContent(listItem) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var itemAttributes, loadContentOperations;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemAttributes = listItem.getAttributes();
                        loadContentOperations = itemAttributes.map(function (attribute) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var itemData, itemBinaryData;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        itemData = listItem[attribute.attrName];
                                        if (!(attribute.dataType === DataTypes_1.DataTypes.Record)) return [3, 2];
                                        return [4, loadItemContent(itemData)];
                                    case 1:
                                        _a.sent();
                                        return [3, 4];
                                    case 2:
                                        if (!(attribute.dataType === DataTypes_1.DataTypes.BinaryData)) return [3, 4];
                                        itemBinaryData = itemData;
                                        return [4, itemBinaryData.loadContent()];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4: return [2];
                                }
                            });
                        }); });
                        return [4, Promise.all(loadContentOperations)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    function toRuntimeName(name) {
        return name.charAt(0).toLowerCase() + name.substr(1) + "Attr";
    }
    function getDynamicSortsObjGenerator(paramValue, entityNames) {
        var sorts = EntityInfoUtils.getDynamicSortList(paramValue, entityNames);
        return function (element) {
            return sorts.map(function (sort) {
                var value = element;
                var _loop_1 = function (i) {
                    var prop = toRuntimeName(sort.attributeParts[i]).toLowerCase();
                    var attr = value.getAttributes().filter(function (attr) { return attr.attrName.toLowerCase() === prop; });
                    if (attr.length === 0) {
                        throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid attribute in 'Order By' parameter: " + sort.attributeParts.join("."));
                    }
                    value = value[attr[0].attrName];
                };
                for (var i = 0; i < sort.attributeParts.length; i++) {
                    _loop_1(i);
                }
                return {
                    value: value,
                    isAscending: sort.isAscending,
                };
            });
        };
    }
    exports.getDynamicSortsObjGenerator = getDynamicSortsObjGenerator;
});
//# sourceMappingURL=IndexedDBUtils.js.map;
